// extracted by mini-css-extract-plugin
export var bold = "_yi-0";